import { getPosterAssetType } from 'phoenix2/components/widgets/video-player/hooks/use-video-callbacks';
import { VIDEO_TYPE_SKILL, VideoType } from 'phoenix2/state/video/video';
import { useSelector } from 'react-redux';
import { didAssetError, getAssetLoadAttempt, isAssetLoaded } from 'phoenix2/state/assets/selectors';

/**
 * Custom hook to get the loading state of the poster
 * @param videoId the assetId for the video
 * @param videoType the type of the video provided
 * @returns an object with properties describing if the poster has been loaded,
 * if the poster has had an error loading, and the number of attempts to load the poster
 */
export const usePosterLoadState = (videoId?: string, videoType?: VideoType) => {
    const posterAssetType = getPosterAssetType(videoType || VIDEO_TYPE_SKILL);

    const errorLoadingPoster = useSelector(state => didAssetError(state, videoId, posterAssetType));
    const posterLoadAttempt: number = useSelector(state =>
        getAssetLoadAttempt(state, videoId, posterAssetType),
    );
    const posterLoaded = useSelector(state => isAssetLoaded(state, videoId, posterAssetType));

    return {
        errorLoadingPoster,
        posterLoadAttempt,
        posterLoaded,
    };
};
